<template>
  <div id="leftSidebar" :class="{'active': sidebarActive}">
    <div class="card">
      <div class="card-header">
        <ul class="row">
          <li :class="['col-xs-4', { 'active': isSelect === 'report' }]" @click="isSelect = 'report'">목록</li>
          <li :class="['col-xs-4', { 'active': isSelect === 'land' }]" @click="isSelect = 'land'">부지평가</li>
          <li :class="['col-xs-4', { 'active': isSelect === 'profit'  }]" @click="isSelect = 'profit'">수익조건변경</li>
        </ul>
      </div>
      <div :class="['card-body', { 'full-card-body': isSelect !== 'profit' }]">
        <div id="reportList" v-show="isSelect === 'report'">
          <div v-if="isStaff" class="all-check-wrap">
            <label class="hz-checkbox">해줌 전체<input type="checkbox" v-model="companyAllCheck" @change="retrieveOthers()">
              <span class="checkmark"></span>
            </label>
          </div>
          <div :class="['grid-wrap', {'all-check-active': isStaff}]">
            <kendo-grid ref="grid"
                        style="border-right: 0;"
                        :options="tableOptions"
                        :columns="tableFields"
                        :dataUrl="dataUrl"
                        :auth="true"
                        :pageSize="20"
                        :message="'저장된 보고서가 없습니다.'"
                        :dblClickRow="viewDetail"></kendo-grid>
          </div>
        </div>
        <div id="landReview" v-show="isSelect === 'land'">
          <div class="form-group">
            <label for="projectName">
              프로젝트명
              <tooltip class="condition-tooltip" :title="tooltipObj.project_name"></tooltip>
            </label>
            <input type="text"
                    maxlength="40"
                    id="projectName"
                    class="hz-input-default hz-input-lg"
                    placeholder="프로젝트명을 입력하세요."
                    v-model="data.project_name">
          </div>
          <div class="form-group">
            <label>
              추진가능성
              <tooltip class="condition-tooltip"
                        :html="true"
                        :title="tooltipObj.grade"
              >
              </tooltip>
            </label>
            <ul class="row">
              <li :class="['review-state-box', 'col-xs-4', { 'active': data.oneclick_grade === '가능' }]" @click="changeGrade('가능')">가능</li>
              <li :class="['review-state-box', 'col-xs-4', 'border-left-none', { 'active':  data.oneclick_grade === '보류' }]" @click="changeGrade('보류')">보류</li>
              <li :class="['review-state-box', 'col-xs-4', 'border-left-none', { 'active':  data.oneclick_grade === '불가' }]" @click="changeGrade('불가')">불가</li>
            </ul>
          </div>
          <div class="form-group">
            <label>
              조례정보
              <tooltip class="condition-tooltip"
                        :html="true"
                        :title="tooltipObj.examine"
              >
              </tooltip>
            </label>
            <textarea class="hz-input-default"
                      rows="10"
                      placeholder="필요한 정보 발췌 후 복사하여 붙여넣기 또는 입력하세요."
                      v-model=" data.oneclick_examine"
            >
            </textarea>
          </div>
          <div class="form-group">
            <label>
              검토의견
              <tooltip class="condition-tooltip"
                        :html="true"
                        :title="tooltipObj.memo"
              >
              </tooltip>
            </label>
            <textarea class="hz-input-default"
                      rows="10"
                      placeholder="1.부지정보:"
                      v-model="data.oneclick_memo"
            >
            </textarea>
          </div>
        </div>
        <div id="profitCondition" v-show="isSelect === 'profit'">
          <div class="collapse-group">
            <div class="collapse-title" data-toggle="collapse" data-target="#basicCondition" aria-expanded="true" aria-controls="basicCondition">
              기본조건 <i class="glyphicon glyphicon-triangle-bottom pull-right"></i>
            </div>
            <div class="collapse in" id="basicCondition" aria-expanded="true">
              <div class="row form-group">
                <label class="col-sm-4">
                  설치용량
                  <tooltip class="condition-tooltip" :title="tooltipObj.expect_capacity"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          v-model="data.oneclick_profit_condition.expect_capacity"
                          @input="toFixed('expect_capacity', data.oneclick_profit_condition.expect_capacity)"
                  >
                  <span class="hz-unit">kWp</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  사업지유형
                  <tooltip class="condition-tooltip" :title="tooltipObj.plant_type"></tooltip>
                </label>
                <div class="col-sm-8">
                  <drop-down-list :options="plantTypeOptions"
                                  :size="'hz-dropdownlist-md'"
                                  :label="''"
                                  v-model="data.oneclick_profit_condition.plant_type"
                                  @input="getRecWeight"
                  >
                  </drop-down-list>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  kW당 공사비
                  <tooltip class="condition-tooltip" :title="tooltipObj.unit_price"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          v-model="data.oneclick_profit_condition.unit_price"
                          @input="toFixed('unit_price', data.oneclick_profit_condition.unit_price)"
                  >
                  <span class="hz-unit">만원/kW</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4 related-field">
                  총 공사비
                  <tooltip class="condition-tooltip" :title="tooltipObj.install_fee"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          v-model="data.oneclick_profit_condition.install_fee"
                          @input="toFixed('install_fee', data.oneclick_profit_condition.install_fee)"
                  >
                  <span class="hz-unit">백만원</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  기타 사업비
                  <tooltip class="condition-tooltip" :title="tooltipObj.business_etc_fee"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          v-model="data.oneclick_profit_condition.business_etc_fee"
                          @input="toFixed('business_etc_fee', data.oneclick_profit_condition.business_etc_fee)"
                  >
                  <span class="hz-unit">백만원</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  계통 연계비
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.connect_fee"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-xs-6">
                      <input type="number"
                              class="hz-input-default hz-input-md"
                              v-model="data.oneclick_profit_condition.connect_fee"
                              @input="toFixed('connect_fee', data.oneclick_profit_condition.connect_fee)"
                              :readonly="isReadOnly"
                      >
                      <span class="hz-unit">백만원</span>
                    </div>
                    <div class="col-xs-6">
                      <button type="button" class="hz-btn-default hz-btn-md" @click="openConnectFeeCalculator">계산기</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4 related-field">
                  총 사업비
                  <tooltip class="condition-tooltip" :title="tooltipObj.business_total_cost"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          v-model="data.oneclick_profit_condition.business_total_cost"
                          @input="toFixed('business_total_cost', data.oneclick_profit_condition.business_total_cost)"
                          readonly
                  >
                  <span class="hz-unit">백만원</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  연간 유지관리비
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.om_fee"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-xs-6">
                      <input type="number"
                              class="hz-input-default hz-input-md"
                              v-model="data.oneclick_profit_condition.om_fee"
                              @input="toFixed('om_fee', data.oneclick_profit_condition.om_fee)"
                      >
                      <span class="hz-unit">백만원</span>
                    </div>
                    <div class="col-xs-6">
                      <button type="button" class="hz-btn-default hz-btn-md" @click="calcOmFee">자동계산</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- username이 3dsolarmap일 경우에 보여지는 영역이다. -->
          <div v-if="user.username === '3dsolarmap'" class="collapse-group" >
            <div class="collapse-title" data-toggle="collapse" data-target="#BIPVCondition" aria-expanded="true" aria-controls="BIPVCondition">
              BIPV조건 <i class="glyphicon glyphicon-triangle-bottom pull-right"></i>
            </div>
            <div class="collapse" id="BIPVCondition" aria-expanded="true">
              <div class="row form-group">
                <label class="col-sm-4">
                  구조유형
                  <tooltip class="condition-tooltip" :title="tooltipObj.bipvStructure"></tooltip>
                </label>
                <div class="col-sm-8">
                  <drop-down-list :options="bipvStructureOptions"
                                  :size="'hz-dropdownlist-md'"
                                  :label="''"
                                  v-model="data.oneclick_profit_condition.bipvStructure"
                                  @input="autoSetCost"
                  >
                  </drop-down-list>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  모듈유형
                  <tooltip class="condition-tooltip" :title="tooltipObj.bipvModule"></tooltip>
                </label>
                <div class="col-sm-8">
                  <drop-down-list :options="bipvModuleOptions"
                                  :size="'hz-dropdownlist-md'"
                                  :label="''"
                                  v-model="data.oneclick_profit_condition.bipvModule"
                                  @input="autoSetCost"
                  >
                  </drop-down-list>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse-group" >
            <div class="collapse-title" data-toggle="collapse" data-target="#saleCondition" aria-expanded="true" aria-controls="saleCondition">
              판매조건 <i class="glyphicon glyphicon-triangle-bottom pull-right"></i>
            </div>
            <div class="collapse" id="saleCondition" aria-expanded="true">
              <div class="row form-group">
                <label class="col-sm-4">
                  SMP 기간
                  <tooltip class="condition-tooltip" :title="tooltipObj.business_period" :html="true"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="1"
                          max="25"
                          v-model="data.oneclick_profit_condition.business_period"
                  >
                  <span class="hz-unit">년</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  SMP 단가
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.smp_price"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          ref="smpPriceField"
                          id="smpPrice"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="99999"
                          v-model="data.oneclick_profit_condition.smp_price"
                          @keyup="isEditingSmpPrice = true"
                          @input="toFixed('smp_price', data.oneclick_profit_condition.smp_price)"
                  >
                  <span class="hz-unit">원/kWh</span>
                  <div class="recent-input-price" v-show="isShowRecentSmpPrice">
                    <ul>
                      <li v-for="smpPrice in recentSmpPrice" @click="selectPriceItem('smp', smpPrice)">
                        <span class="price">{{ smpPrice }}</span>
                        <span class="hz-unit">원/kWh</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  REC 기간
                  <tooltip class="condition-tooltip" :title="tooltipObj.rec_period" :html="true"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="25"
                          v-model="data.oneclick_profit_condition.rec_period"
                  >
                  <span class="hz-unit">년</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  REC 단가
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.rec_price"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          ref="recPriceField"
                          id="recPrice"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="99999"
                          v-model="data.oneclick_profit_condition.rec_price"
                          @keyup="isEditingRecPrice = true"
                          @input="toFixed('rec_price', data.oneclick_profit_condition.rec_price)"
                  >
                  <span class="hz-unit">원/kWh</span>
                  <div class="recent-input-price" v-show="isShowRecentRecPrice">
                    <ul>
                      <li v-for="recPrice in recentRecPrice" @click="selectPriceItem('rec', recPrice)">
                        <span class="price">{{ recPrice }}</span>
                        <span class="hz-unit">원/kWh</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4 related-field">
                  REC 가중치
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.rec_weight"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          v-model="data.oneclick_profit_condition.rec_weight"
                          @input="toFixed('rec_weight', data.oneclick_profit_condition.rec_weight)"
                  >
                  <span class="hz-unit">배</span>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse-group">
            <div class="collapse-title" data-toggle="collapse" data-target="#installCondition" aria-expanded="true" aria-controls="installCondition">
              설치조건 <i class="glyphicon glyphicon-triangle-bottom pull-right"></i>
            </div>
            <div class="collapse" id="installCondition" aria-expanded="true">
              <div class="row form-group">
                <label class="col-sm-4">
                  발전시간
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.average_generate_time"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-xs-6">
                      <input type="number"
                              class="hz-input-default hz-input-md"
                              min="0"
                              max="24"
                              v-model="data.oneclick_profit_condition.average_generate_time"
                              @input="toFixed('average_generate_time', data.oneclick_profit_condition.average_generate_time)"
                              :readonly="$parent.requestState.analysis.state === 'load'"
                      >
                      <span class="hz-unit">시간/일</span>
                    </div>
                    <div class="col-xs-6">
                      <button type="button" class="hz-btn-default hz-btn-md" @click="getAnalysis(true)">자동계산</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  향
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.aspect"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="360"
                          v-model="data.oneclick_profit_condition.aspect"
                          @input="toFixed('aspect', data.oneclick_profit_condition.aspect)"
                  >
                  <span class="hz-unit">도</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  경사각
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.tilt_angle"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="90"
                          v-model="data.oneclick_profit_condition.tilt_angle"
                          @input="toFixed('tilt_angle', data.oneclick_profit_condition.tilt_angle)"
                  >
                  <span class="hz-unit">도</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  음영손실
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.tilt_angle"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="100"
                          v-model="data.oneclick_profit_condition.shade_lose"
                          @input="toFixed('shade_lose', data.oneclick_profit_condition.shade_lose)"
                  >
                  <span class="hz-unit">%</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  운휴일
                  <tooltip class="condition-tooltip"
                            :html="true"
                            :title="tooltipObj.suspension_date_cnt"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="365"
                          v-model="data.oneclick_profit_condition.suspension_date_cnt"
                          @input="toFixed('suspension_date_cnt', data.oneclick_profit_condition.suspension_date_cnt)"
                  >
                  <span class="hz-unit">일</span>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse-group">
            <div class="collapse-title" data-toggle="collapse" data-target="#financeCondition" aria-expanded="true" aria-controls="financeCondition">
              금융조건 <i class="glyphicon glyphicon-triangle-bottom pull-right"></i>
            </div>
            <div class="collapse" id="financeCondition" aria-expanded="true">
              <div class="row form-group">
                <label class="col-sm-4">
                  사업자유형
                  <tooltip class="condition-tooltip" :title="tooltipObj.business_type"></tooltip>
                </label>
                <div class="col-sm-8">
                  <drop-down-list :options="businessOptions"
                                  :size="'hz-dropdownlist-md'"
                                  :label="''"
                                  v-model="data.oneclick_profit_condition.business_type"
                  >
                  </drop-down-list>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  대출비율
                  <tooltip class="condition-tooltip" :title="tooltipObj.loan_rate"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="100"
                          v-model="data.oneclick_profit_condition.loan_rate"
                          @input="toFixed('loan_rate', data.oneclick_profit_condition.loan_rate)"
                  >
                  <span class="hz-unit">%</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4 related-field">
                  대출금액
                  <tooltip class="condition-tooltip" :title="tooltipObj.loan"></tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="99999"
                          v-model="data.oneclick_profit_condition.loan"
                          @input="toFixed('loan', data.oneclick_profit_condition.loan)"
                  >
                  <span class="hz-unit">백만원</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">대출금리</label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="100"
                          v-model="data.oneclick_profit_condition.interest_rate"
                          @input="toFixed('interest_rate', data.oneclick_profit_condition.interest_rate)"
                          :readonly="hasNotLoan"
                  >
                  <span class="hz-unit">%</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">거치기간</label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="100"
                          v-model="data.oneclick_profit_condition.loan_period"
                          @input="toFixed('loan_period', data.oneclick_profit_condition.loan_period)"
                          :readonly="hasNotLoan"
                  >
                  <span class="hz-unit">년</span>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-sm-4">
                  상환기간
                  <tooltip class="condition-tooltip"
                            :title="tooltipObj.redemption_period"
                            :position="'top'"
                  >
                  </tooltip>
                </label>
                <div class="col-sm-8">
                  <input type="number"
                          class="hz-input-default hz-input-md"
                          min="0"
                          max="100"
                          v-model="data.oneclick_profit_condition.redemption_period"
                          @input="toFixed('redemption_period', data.oneclick_profit_condition.redemption_period)"
                          :readonly="hasNotLoan"
                  >
                  <span class="hz-unit">년</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isSelect === 'profit'" class="card-footer">
        <button class="hz-btn-primary hz-btn-lg" style="border-radius: initial;" @click="setAdjust()">적용</button>
      </div>
    </div>
    <a href="#" class="toggle" @click.prevent="toggleMenu()">
      <i :class="['glyphicon', toggleIconClass]" style="font-size: 12px; font-weight: normal;"></i>
    </a>
  </div>
</template>

<script>
  import KendoGrid from 'common/components/KendoGrid'
  import DropDownList from 'common/components/DropDownList'
  import InputNumber from 'common/components/InputNumber'
  import Tooltip from 'common/components/Tooltip'
  import eventHub from '@/shared/EventHub'
  import conditionTooltip from '@/assets/js/condition-tooltip.js'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'left-sidebar',
    components: {
      KendoGrid,
      DropDownList,
      InputNumber,
      Tooltip
    },
    props: {
      value: {
        type: Object,
        default () {
          return {}
        }
      },
      sidebarActive: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    data () {
      return {
        isSelect: 'report',
        dataSetDone: false,
        companyAllCheck: false,
        isFocusSmpPrice: false,
        isEditingSmpPrice: false,
        isFocusRecPrice: false,
        isEditingRecPrice: false,
        isReadOnly: false,
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/review/list/',
        businessOptions: [
          {name: '개인사업자', value: 'IDV'},
          {name: '법인사업자', value: 'CRP'}
        ],
        plantTypeOptions: [
          {name: '건물', value: 'BD'},
          {name: '토지', value: 'LD'},
          {name: '임야', value: 'MT'}
        ],
        tableFields: [
          {
            field: 'project_name',
            title: '프로젝트명',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: false
          },
          {
            field: 'oneclick_grade',
            title: '평가',
            type: 'string',
            width: '80px',
            sortable: false,
            filterable: {multi: true, search: true},
            template: function (dataItem) {
              let template = ''
              const state = dataItem['oneclick_grade']
              // 단독주택 서비스 일 경우
              if (state === '가능') {
                template = `<div class='state-tag possible-tag'>가능</div>`
              } else if (state === '불가') {
                template = `<div class='state-tag impossible-tag'>불가</div>`
              } else if (state === '보류') {
                template = `<div class='state-tag hold-tag'>보류</div>`
              } else {
                template = `<div class='state-tag'>미정</div>`
              }
              return template
            }
          },
          {
            field: 'report',
            title: '보고서',
            type: 'string',
            width: '70px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              return `<i rpid='` + dataItem['id'] + `'
                        class='glyphicon glyphicon-download-alt' style='cursor: pointer; font-weight: bold;'></i>`
            }
          },
          {
            field: 'delete',
            title: '삭제',
            type: 'string',
            width: '60px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              return `<div rpid='` + dataItem['id'] + `' title= '` + dataItem['project_name'] + `' class='k-grid-remove' style='cursor: pointer;'>☓</div>`
            }
          }
        ],
        data: {
          project_name: '',
          oneclick_grade: '미정',
          oneclick_examine: '',
          oneclick_memo: '',
          oneclick_profit_condition: {}
        },
        oldInstallOptions: {},
        tableOptions: {
          parameter: [
            { name: 'all_check', value: 'N' }
          ],
          pageable: {
            pageSize: 20,
            buttonCount: 5,
            refresh: true,
            info: false
          }
        },
        tooltipObj: conditionTooltip,
        bipvStructureOptions: [
          {name: '해당없음', value: '해당없음'},
          {name: '건식입면', value: '건식입면'},
          {name: '경량철골', value: '경량철골'},
          {name: '커튼월', value: '커튼월'}
        ],
        bipvModuleOptions: [
          {name: '해당없음', value: '해당없음'},
          {name: 'Clear', value: 'Clear'},
          {name: 'All Black', value: 'All Black'},
          {name: 'Medium Gray', value: 'Medium Gray'}
        ]
      }
    },
    computed: {
      ...mapGetters({
        user: 'user',
        condition: 'condition',
        isPaidMember: 'isPaidMember',
        recentSmpPrice: 'recent_smp_price',
        recentRecPrice: 'recent_rec_price'
      }),
      isStaff () {
        return this.user.auth_level === '90'
      },
      isShowRecentSmpPrice () {
        const hasRecentPriceItems = this.recentSmpPrice.length > 0

        return hasRecentPriceItems && this.isFocusSmpPrice && !this.isEditingSmpPrice
      },
      isShowRecentRecPrice () {
        const hasRecentPriceItems = this.recentRecPrice.length > 0

        return hasRecentPriceItems && this.isFocusRecPrice && !this.isEditingRecPrice
      },
      toggleIconClass () {
        return this.sidebarActive ? 'glyphicon-menu-left' : 'glyphicon-menu-right'
      },
      hasNotLoan () {
        return this.data.oneclick_profit_condition.loan_rate === 0
      }
    },
    watch: {
      'sidebarActive': {
        handler (val) {
          const isPcScreen = this.$parent.checkScreenWidth()

          // PC 스크린이 아닐 경우에만 실행한다. (1200px 미만)
          if (!isPcScreen) {
            const isHidden = val ? 'hidden' : ''
            this.setOverflow(isHidden)
          }
        }
      },
      'data.oneclick_profit_condition.expect_capacity': {
        handler () {
          if (this.dataSetDone) {
            this.calcInstallFee()
            this.getRecWeight()
          }
        }
      },
      'data.oneclick_profit_condition.unit_price': {
        handler () {
          if (this.dataSetDone) {
            this.calcInstallFee()
          }
        }
      },
      'data.oneclick_profit_condition.install_fee': {
        handler () {
          if (this.dataSetDone) {
            this.calcTotalCost()
          }
        }
      },
      'data.oneclick_profit_condition.business_etc_fee': {
        handler () {
          if (this.dataSetDone) {
            this.calcTotalCost()
          }
        }
      },
      'data.oneclick_profit_condition.connect_fee': {
        handler () {
          if (this.dataSetDone) {
            this.calcTotalCost()
          }
        }
      },
      'data.oneclick_profit_condition.business_total_cost': {
        handler () {
          if (this.dataSetDone) {
            // 대출비율이 있을경우, 총 사업비 변경에 따른 대출금액 계산
            if (this.data.oneclick_profit_condition.loan_rate > 0) {
              this.calcLoan()
            }
          }
        }
      },
      'data.oneclick_profit_condition.loan_rate': {
        handler (val) {
          if (this.dataSetDone) {
            this.calcLoan()

            if (val === 0) {
              this.data.oneclick_profit_condition.interest_rate = 0
              this.data.oneclick_profit_condition.loan_period = 0
              this.data.oneclick_profit_condition.redemption_period = 0
            }
          }
        }
      },
      'data.oneclick_profit_condition.business_period': {
        handler: _.debounce(function (val) {
          if (this.dataSetDone) {
            this.data.oneclick_profit_condition.business_period = Math.min(Math.max(1, val), 25)
          }
        }, 500)
      },
      'data.oneclick_profit_condition.rec_period': {
        handler: _.debounce(function (val) {
          if (this.dataSetDone) {
            this.data.oneclick_profit_condition.rec_period = Math.min(Math.max(0, val), 25)
          }
        }, 500)
      },
      'data.oneclick_profit_condition.bipvStructure': {
        handler () {
          if (this.dataSetDone) {
            // this.calcTotalCost()
            this.autoSetCost()
          }
        }
      },
      'data.oneclick_profit_condition.bipvModule': {
        handler () {
          if (this.dataSetDone) {
            // this.calcTotalCost()
            this.autoSetCost()
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'setRecentInputPrice'
      ]),
      calcInstallFee: _.debounce(function () {
        const vm = this
        const capcity = parseFloat(vm.data.oneclick_profit_condition['expect_capacity'])
        const price = parseFloat(vm.data.oneclick_profit_condition['unit_price'])
        const install = parseFloat(((capcity * price) * 0.01).toFixed(3))

        // 용량 * kW당 공사비를 총공사비 항목에 넣어준다.
        vm.data.oneclick_profit_condition['install_fee'] = install
      }, 300),
      calcOmFee: _.debounce(function () {
        const capcity = parseFloat(this.data.oneclick_profit_condition.expect_capacity)
        const omFee = parseFloat(((capcity / 100) * 2.5).toFixed(3))

        // 100kW당 2.5 백만원/년을 연간 유지비 데이터에 넣어준다.
        this.data.oneclick_profit_condition.om_fee = omFee
      }, 300),
      calcTotalCost: _.debounce(function () {
        const condition = this.data.oneclick_profit_condition

        // 총 공사비, 계통연계비, 착수금, 토지비, 대출수수료, 기타사업비
        const installFee = parseFloat(condition.install_fee)
        const connectFee = parseFloat(condition.connect_fee)
        const retainingFee = parseFloat(condition.retaining_fee)
        const landFee = parseFloat(condition.land_fee)
        const loanCommissionFee = parseFloat(condition.loan_commission_fee)
        const businessEtcFee = parseFloat(condition.business_etc_fee)

        // 총 사업비 = 총 공사비 + 게통연계비 + 착수금 + 토지비 + 대출수수료 + 기타사업비
        const total = parseFloat((installFee + connectFee + retainingFee + landFee + loanCommissionFee + businessEtcFee).toFixed(3))

        // 총 공사비 + 기타사업비 + 계통연계비를 합한 값을 총 사업비에 넣어준다.
        this.data.oneclick_profit_condition.business_total_cost = total
      }, 300),
      calcLoan: _.debounce(function () {
        const condition = this.data.oneclick_profit_condition
        const total = parseFloat(condition.business_total_cost)
        const rate = parseFloat(condition.loan_rate)

        // 총 사업비/대출비율
        const loan = parseFloat((total * (rate * 0.01)).toFixed(3))

        this.data.oneclick_profit_condition.loan = loan
      }, 300),
      changeGrade (state) {
        const grade = this.data.oneclick_grade
        this.data.oneclick_grade = grade === state ? '미정' : state
      },
      setAdjust () {
        // 입력된 BIPV조건을 로컬 스토리지에 저장한다.
        localStorage.setItem('bipvStructure', this.data.oneclick_profit_condition.bipvStructure)
        localStorage.setItem('bipvModule', this.data.oneclick_profit_condition.bipvModule)
        this.getAnalysis()
        this.getProfit()
      },
      getAnalysis (autoApply = false) {
        // 유료 회원이 아닐 경우, 알림창을 띄운다.
        if (!this.isPaidMember) {
          eventHub.$emit('showChargeModal')
          return false
        }

        // 스크린 사이즈가 PC가 아닐 경우(width 1200px 미만) 조건탭을 닫는다.
        const parent = this.$parent
        parent.sidebarActive = parent.checkScreenWidth()

        console.log('auto apply', autoApply)

        // 발전정보 API 호출
        this.$emit('getAnalysis', {navigate: true, showToastMessage: true, autoApply: autoApply})
      },
      getProfit () {
        // 유료 회원이 아닐 경우, 알림창을 띄운다.
        if (!this.isPaidMember) {
          eventHub.$emit('showChargeModal')
          return false
        }

        // 모바일 사이즈 일 경우 사이드바를 닫는다.
        const parent = this.$parent
        parent.sidebarActive = parent.checkScreenWidth()

        const condition = this.data.oneclick_profit_condition
        const currentInstallOptions = {
          aspect: condition.aspect,
          tilt_angle: condition.tilt_angle,
          shade_lose: condition.shade_lose,
          suspension_date_cnt: condition.suspension_date_cnt
        }

        // 설치조건 변경 여부에 따라 수익분석 또는 발전/수익분석을 실행한다.
        const params = { navigate: true, showToastMessage: true }
        if (_.isEqual(currentInstallOptions, this.oldInstallOptions)) {
          this.$emit('getProfit', params)
        } else {
          this.$emit('getAnalysisProfit', params)
        }

        // 입력된 SMP, REC 가격을 로컬 스토리지에 저장한다.
        this.setRecentInputPrice({target: 'smp_price', price: this.data.oneclick_profit_condition.smp_price})
        this.setRecentInputPrice({target: 'rec_price', price: this.data.oneclick_profit_condition.rec_price})
      },
      getRecWeight: _.debounce(function () {
        this.$emit('getRecWeight')
      }, 500),
      openConnectFeeCalculator () {
        // 표준시설부담금 계산기
        // 한전 사이버지점(cyber.kepco.co.kr)이 한전ON 으로 통합되면서 기존 주소는
        // 한전ON 메인으로 리다이렉트된다. 계산기 페이지로 직접 연결한다. (2026-09-03)
        const url = 'https://online.kepco.co.kr/PRM076D00'
        const left = (screen.width / 2) - (1280 / 2)
        const top = (screen.height / 2) - (720 / 2)

        window.open(url, 'preview', `menubar=0, resizable=0, width=1280, height=720, top=${top}, left=${left} + left`)
      },
      refresh () {
        this.$refs.grid.refresh()
      },
      retrieveOthers () {
        const vm = this
        const isAll = vm.companyAllCheck ? 'Y' : 'N'

        // 보고서 전체보기 클릭 여부에 따라 목록 API Parameter를 설정해준다.
        vm.tableOptions.parameter = [
          {name: 'all_check', value: isAll}
        ]

        // 보고서 목록 업데이트
        vm.$refs.grid.refresh()
      },
      setOverflow (state = 'auto') {
        /**
         *  컨텐츠에 스크롤을 제어합니다.
         *  사이드바 활성화 여부에 따라 body에 overflow 속성을 할당해줍니다.
         *  사이드바 활성화 시 overflow 비활성화
         *  사이브다 비활성화 시 overflow 활성화
         */
        document.getElementsByTagName('body')[0].setAttribute('style', `overflow: ${state};`)
      },
      setOldInstallOptions () {
        // 설치조건 변경여부를 확인하기위해 비교 데이터를 설정한다.
        const condition = this.data.oneclick_profit_condition
        this.oldInstallOptions = {
          aspect: condition.aspect,
          tilt_angle: condition.tilt_angle,
          shade_lose: condition.shade_lose,
          suspension_date_cnt: condition.suspension_date_cnt
        }
      },
      selectPriceItem (type = '', price = 0) {
        this.data.oneclick_profit_condition[`${type}_price`] = parseFloat(price)
      },
      toFixed: _.debounce(function (field, value, size = 3) {
        /**
         * input type = number인 필드에 값이 입력 될 때 호출되는 함수입니다.
         * 최종 이벤트 발생 후 1초뒤에 실행합니다.
         * 입력이 공백 일 경우 0을 자동으로 반환합니다.
         * 입력 된 수에 소수점 자릿수를 잘라 반환합니다.
         */

        const vm = this
        const number = isNaN(parseFloat(value)) ? 0 : parseFloat(parseFloat(value).toFixed(size))

        // 해당 필드에 데이터 Set
        vm.$set(vm.data.oneclick_profit_condition, field, number)
      }, 300),
      toggleMenu (target = '') {
        this.$parent.sidebarActive = target ? true : !this.sidebarActive

        if (target) {
          switch (target) {
            case 'land':
              this.isSelect = 'land'
              break

            case 'profit':
              this.isSelect = 'profit'
              $('#installCondition').collapse('hide')
              $('#basicCondition').collapse('show')
              break

            case 'analysis':
              this.isSelect = 'profit'
              $('#basicCondition').collapse('hide')
              $('#installCondition').collapse('show')
              break
          }
        }
      },
      viewDetail (id, data, flag = false) {
        const current = this.$route.params.id

        // 보고서 신규생성에 경우 저장되지 않았다면 알림창을 띄운다
        if (typeof current === 'undefined') {
          if (!confirm('현재 보고서가 저장되지 않은 상태입니다. 다른 보고서로 이동하시겠습니까?')) {
            return
          }
        }
        // 현재 보고서 ID와 선택된 ID가 같지 않을 경우에만 실행
        if (Number(current) !== Number(id)) {
          // 클릭된 보고서에 ID로 라우터 세팅
          this.$router.push({name: 'oneclickLoad', params: {id: id, preview: flag}})
          // 화면 초기화 및 보고서 데이터 불러오기
          this.$parent.getReport(id)
        } else {
          alert('현재 선택된 보고서 입니다.')
        }
      },
      autoSetCost: _.debounce(function () {
        // alert('set!')
        // 둘중 하나라도 해당없음이면 빈 값으로 설정한다.(설정할 값 없음)
        if (this.data.oneclick_profit_condition.bipvStructure === '해당없음' || this.data.oneclick_profit_condition.bipvModule === '해당없음') {
          this.data.oneclick_profit_condition.unit_price = '0'
          this.data.oneclick_profit_condition.om_fee = '0'
        }
        // 둘다 해당없음이면 계통 연계비를 비활성화 한다.
        if (this.data.oneclick_profit_condition.bipvStructure === '해당없음' && this.data.oneclick_profit_condition.bipvModule === '해당없음') {
          this.isReadOnly = true
        } else {
          this.isReadOnly = false
        }

        // 건식입면 케이스
        if (this.data.oneclick_profit_condition.bipvStructure === '건식입면') {
          if (this.data.oneclick_profit_condition.bipvModule === 'Clear') {
            this.data.oneclick_profit_condition.unit_price = '541.10'
            this.data.oneclick_profit_condition.om_fee = '0.054'
          } else if (this.data.oneclick_profit_condition.bipvModule === 'All Black') {
            this.data.oneclick_profit_condition.unit_price = '541.10'
            this.data.oneclick_profit_condition.om_fee = '0.054'
          } else if (this.data.oneclick_profit_condition.bipvModule === 'Medium Gray') {
            this.data.oneclick_profit_condition.unit_price = '677.98'
            this.data.oneclick_profit_condition.om_fee = '0.067'
          }
        }
        // 경량철골 케이스
        if (this.data.oneclick_profit_condition.bipvStructure === '경량철골') {
          if (this.data.oneclick_profit_condition.bipvModule === 'Clear') {
            this.data.oneclick_profit_condition.unit_price = '522.48'
            this.data.oneclick_profit_condition.om_fee = '0.052'
          } else if (this.data.oneclick_profit_condition.bipvModule === 'All Black') {
            this.data.oneclick_profit_condition.unit_price = '522.48'
            this.data.oneclick_profit_condition.om_fee = '0.052'
          } else if (this.data.oneclick_profit_condition.bipvModule === 'Medium Gray') {
            this.data.oneclick_profit_condition.unit_price = '656.43'
            this.data.oneclick_profit_condition.om_fee = '0.065'
          }
        }
        // 커튼월 케이스
        if (this.data.oneclick_profit_condition.bipvStructure === '커튼월') {
          if (this.data.oneclick_profit_condition.bipvModule === 'Clear') {
            this.data.oneclick_profit_condition.unit_price = '694.39'
            this.data.oneclick_profit_condition.om_fee = '0.069'
          } else if (this.data.oneclick_profit_condition.bipvModule === 'All Black') {
            this.data.oneclick_profit_condition.unit_price = '694.39'
            this.data.oneclick_profit_condition.om_fee = '0.069'
          } else if (this.data.oneclick_profit_condition.bipvModule === 'Medium Gray') {
            this.data.oneclick_profit_condition.unit_price = '855.43'
            this.data.oneclick_profit_condition.om_fee = '0.085'
          }
        }

        // 공사비와 유지관리비 값 변경 후 toFixed 처리를 해줘서 입력된 값과 동일하게 처리.
        this.toFixed('unit_price', this.data.oneclick_profit_condition.unit_price)
        this.toFixed('om_fee', this.data.oneclick_profit_condition.om_fee)
      }, 200)
    },
    created () {
      // 컴포넌트 데이터 초기화
      this.data = this.value

      this.$nextTick(() => {
        this.setOldInstallOptions()
        this.dataSetDone = true
      })
    },
    mounted () {
      // 보고서 목록에 리사이즈 문제로 isSelect 초기값을 report => profit으로 단계를 거쳐 변경
      this.isSelect = 'profit'

      // SMP 가격 필드 focus, blur 이벤트 등록
      const smpPrice = document.querySelector('#smpPrice')
      smpPrice.addEventListener('focus', () => {
        this.isFocusSmpPrice = true
      })
      smpPrice.addEventListener('blur', () => {
        setTimeout(() => {
          this.isFocusSmpPrice = false
          this.isEditingSmpPrice = false
        }, 150)
      })

      // REC 가격 필드 focus, blur 이벤트 등록
      const recPrice = document.querySelector('#recPrice')
      recPrice.addEventListener('focus', () => {
        this.isFocusRecPrice = true
      })
      recPrice.addEventListener('blur', () => {
        setTimeout(() => {
          this.isFocusRecPrice = false
          this.isEditingRecPrice = false
        }, 150)
      })
    },
    beforeDestroy () {
      // 페이지 이동 시 스크롤을 활성화
      this.setOverflow()
    }
  }
</script>
  
  <style lang="scss" scoped>
    $left-sidebar-width: 400px;
    $hide-position: -400px;
    $grey-bg-color: #f7f9fa;
    $box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.16), 0 1px 1px 0 rgba(0, 0, 0, 0.23);
    $active-color: #26507a;
  
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
  
    input,
    textarea {
      width: 100%;
      padding: 16px;
    }
  
    #leftSidebar {
      width: $left-sidebar-width;
      height: 100%;
      position: fixed;
      top: 64px;
      left: $hide-position;
      background-color: $hzc-white;
      z-index: 9;
      transition: all .5s ease;
  
      &.active {
        left: 0;
        .toggle {
          left: 399px;
        }
      }
  
      @media (max-width: 767px) {
        width: calc(100% - 40px);
        left: calc(-100% + 40px);
  
        &.active .toggle {
          left: calc(100% - 1px);
          opacity: 1;
        }
      }
  
      .card {
        width: 100%;
        height: 100%;
        overflow: hidden;
        box-shadow: $z-depth-01;
        float: left;
  
        .card-header {
          border-width: 0 1px 1px 0;
          border-style: solid;
          border-color: $hzc-gray-04;
  
          ul {
            box-shadow : 0 1px 1px 0 rgba(0,0,0,.16), 0 1px 1px 0 rgba(0,0,0,.23);
          }
  
          li {
            height: 48px;
            display: inline-block;
            text-align: center;
            line-height: 48px;
            font-size: 14px;
            color: $hzc-gray-06;
            cursor: pointer;
  
            &.active,
            &:hover {
              color: $active-color;
              border-bottom: 4px solid $active-color;
            }
          }
        }
  
        .card-body {
          height: calc(100% - 160px);
          overflow-x: hidden;
          overflow-y: auto;
          border-right: 1px solid $hzc-gray-04;
        }
  
        .card-footer {
          height: 48px;
  
          button {
            width: 100%;
          }
        }
  
        .full-card-body {
          height: calc(100% - 112px);
  
          @media (max-width: 991px) {
            height: calc(100% - 110px);
          }
        }
  
        .form-group {
          label {
            margin: 0;
            font-size: 14px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            color: $header-color;
            line-height: 32px;
          }
        }
  
        .condition-tooltip {
          float: right;
        }
      }
  
      .toggle {
        position: absolute;
        top: calc(50% - 96px);
        width: 25px;
        height: 48px;
        line-height: 48px;
        font-size: 14px;
        color: $hzc-gray-07;
        text-align: center;
        background-color: $hzc-white;
        border-width: 1px 1px 1px 0;
        border-style: solid;
        border-color: $hzc-gray-04;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.12);
        float: left;
  
        @media (max-width: 767px) {
          opacity: 0.75;
        }
      }
    }
  
    #reportList {
      height: 100%;
      overflow: hidden;
  
      .all-check-wrap {
        height: 28px;
        padding: 4px 8px;
      }
  
      .grid-wrap {
        height: 100%;
  
        &.all-check-active {
          height: calc(100% - 28px);
        }
      }
    }
  
    #landReview {
      padding: 24px 16px 0;
  
      ul {
        .review-state-box {
          width: 33.33%;
          height: 48px;
          line-height: 48px;
          border: 1px solid #e1e6f3;
          color: $primary-color-v2;
          font-weight: bold;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          background-color: #f7f8fc;
          box-shadow: 0 1px 1px 0 rgba(102, 105, 109, 0.32);
  
          &:hover {
            background-color: $primary-color-v2;
            color: $hzc-white;
          }
  
          &:active {
            background-color: darken($primary-color-v2, 10%);
            color: $hzc-white;
          }
        }
        .active {
          background-color: $primary-color-v2;
          color: $hzc-white;
        }
      }
  
      .form-group {
        margin: 0 0 24px;
  
        label {
          width: 88px;
        }
      }
    }
  
    #profitCondition {
      height: 100%;
      width: 100%;
  
      .collapse-group {
        display: block;
        width: 100%;
        height: auto;
        background-color: $hzc-white;
        cursor: pointer;
      }
  
      .collapse-title {
        height: 100%;
        padding: 0 16px;
        background-color: $hzc-white;
        border-width: 1px 0 1px 1px;
        border-style: solid;
        border-color: $hzc-gray-03;
        line-height: 48px;
        &:hover { background-color: darken($hzc-white, 10%); }
        &:active { background-color: darken($hzc-white, 20%); }
      }
  
      .collapse {
        width: 100%;
      }
  
      .form-group {
        display: inline-block;
        width: 100%;
        margin: 4px 0;
        padding: 0 16px;
  
        &:first-child {
          margin: 16px 0 4px;
        }
  
        &:last-child {
          margin: 4px 0 16px;
        }
  
        label {
          margin: 0;
  
          &.related-field {
            color: $hzc-gray-05;
          }
  
          @media (max-width: $screen-xs-max) {
            width: 120px;
          }
        }
  
        .col-sm-4 {
          padding: 0 8px 0 0;
        }
  
        .col-sm-8,
        .col-xs-6 {
          padding: 0;
        }
  
        .hz-btn-default {
          width: 100%;
          line-height: 30px;
          border-left: none;
          font-size: 12px;
        }
  
        .hz-unit {
          position: absolute;
          top: 9px;
          right: 16px;
          font-size: 12px;
          font-weight: bold;
          color: $hzc-gray-05;
        }
      }
  
      .recent-input-price {
        position: absolute;
        width: 100%;
        height: auto;
        max-height: 250px;
        overflow: auto;
        margin-top: 4px;
        border-radius: 4px;
        -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
        background-color: $hzc-white;
        text-align: left;
        z-index: 7;
  
        ul {
          overflow: auto;
        }
  
        li {
          position: relative;
          padding: 4px 8px;
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: -0.35px;
          color: $font-color;
        }
  
        li:first-child {
          padding-top: 8px;
        }
  
        li:last-child {
          padding-bottom: 8px;
        }
  
        li:hover {
          background-color: #f5f2fc;
          color: $purple;
        }
      }
  
      .glyphicon-triangle-bottom {
        top: 0;
        line-height: 48px;
        font-size: 9px;
      }
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/LeftSidebarDetail.vue